import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { ProductLayoutDetailsGeneralItemComponent } from './item/product-layout-details-general-item.component';
import { ProductLayoutDetailsGeneralAbstractComponent } from './product-layout-details-general.abstract';

@Component({
    selector: 'product-layout-details-general',
    templateUrl: './product-layout-details-general.component.html',
    imports: [AttributeLabelPipe, CommonModule, ProductLayoutDetailsGeneralItemComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutDetailsGeneralComponent extends ProductLayoutDetailsGeneralAbstractComponent {
    protected override readonly attribute = 'detailsAttributes';
}
